
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M20 13h-1.222l1.05-1.05C20.584 11.195 21 10.19 21 9.121s-.416-2.073-1.172-2.828l-2.121-2.121c-1.511-1.512-4.146-1.511-5.657 0L11 5.222V4c0-2.206-1.794-4-4-4H4C1.794 0 0 1.794 0 4v14.5C0 21.533 2.467 24 5.5 24H20c2.206 0 4-1.794 4-4v-3c0-2.206-1.794-4-4-4zm-6.536-7.414c.755-.755 2.072-.756 2.829 0l2.121 2.121c.378.378.586.88.586 1.414s-.208 1.037-.586 1.415L11 17.95v-9.9l2.464-2.464zM2 8h7v4H2V8zm2-6h3c1.103 0 2 .897 2 2v2H2V4c0-1.103.897-2 2-2zM2 18.5V14h7v4.5C9 20.43 7.43 22 5.5 22S2 20.43 2 18.5zM22 20c0 1.103-.897 2-2 2H9.778l7-7H20c1.103 0 2 .897 2 2v3zM5.5 20a1.5 1.5 0 11.001-3.001A1.5 1.5 0 015.5 20z"}})])
          )
        }
      }
    